import React, { Component } from "react";
import "react-moment";
import moment from "moment";
import DashboardRecharts from "./Ventadia";
import DashboardVentasMes from "./VentasMes";
import DashboardVentasHistoricas from "./Ventashistoricas";
import './NuevoDashboard.css';

class NuevoDashboard extends Component {
    constructor(props){
        super(props);
        this.state = {
            TotalVentas: null,
            TotalProductosAgotarStock: null,
            TotalProductosVales: null,
            dataVentasDia: [],
            dataVentasPorMes: [],
            dataVentasPorSemana: [],
            dataMediosPago: [],
            FechaInicio: moment().add(-30, 'days'),
            FechaFin: new Date(),
            MesActual: "",

        };
        this.handleVerVentasTurnosActivosEmpresa = this.handleVerVentasTurnosActivosEmpresa.bind(this);
        this.handleVerProductosAgotarStock = this.handleVerProductosAgotarStock.bind(this);
        this.handleIrProductosMasVendidos = this.handleIrProductosMasVendidos.bind(this);
        this.handleReportesStock = this.handleReportesStock.bind(this);
        this.getVentasDelDia = this.getVentasDelDia.bind(this);
        this.getVentasPorSemana = this.getVentasPorSemana.bind(this);
        this.getVentasPorMes = this.getVentasPorMes.bind(this);
        this.getMediosPago = this.getMediosPago.bind(this);
    }

    componentDidMount() {
        let Inicio = moment(this.state.FechaInicio).format("YYYY-MM-DD");
        let Fin = moment(this.state.FechaFin).format("YYYY-MM-DD");
        

        const mesNumero = new Date().getMonth();
        this.mesLetras(mesNumero);
        this.getVentasDelDia(Fin);
        this.getVentasPorSemana(Fin);
        this.getVentasPorMes(Fin);
        this.getMediosPago(Fin);
    }

    // Función que convierte número de mes a nombre
    mesLetras = (mesNumero) => {
        const month = [
            "ENERO",
            "FEBRERO",
            "MARZO",
            "ABRIL",
            "MAYO",
            "JUNIO",
            "JULIO",
            "AGOSTO",
            "SETIEMBRE",
            "OCTUBRE",
            "NOVIEMBRE",
            "DICIEMBRE"
        ];
        
        this.setState({
            MesActual: month[mesNumero]
        });
    }

    getVentasDelDia = async (Hoy) => {
        try {
            const response = await fetch(
                `/api/dashboard/get/ventasDia/${Hoy}`
            );
            const ReporteVentasDia = await response.json();
            this.setState({
                dataVentasDia: ReporteVentasDia.respuesta,
                isLoading: false,
            });

            return ReporteVentasDia;
        } catch (error) {
            this.setState({error, isLoading: false})
        }
    }

    getVentasPorSemana = async (Hoy) => {
        try {
            const response = await fetch(
                `/api/dashboard/get/ventasSemanas/${Hoy}`
            );
            const ReporteVentasSemana = await response.json();
            this.setState({
                dataVentasPorSemana: ReporteVentasSemana,
                isLoading: false,
            });

            return ReporteVentasSemana;
        }
        catch (error) {
            this.setState({error, isLoading: false})
        }
    }

    getVentasPorMes = async (Hoy) => {
        try {
            const response = await fetch(
                `/api/dashboard/get/ventasMeses/${Hoy}`
            );
            const ReporteVentasPorMeses = await response.json();
            this.setState({
                dataVentasPorMeses: ReporteVentasPorMeses.respuesta,
                isLoading: false
            });

            return ReporteVentasPorMeses;
        } catch (error) {
            this.setState({error, isLoading: false})
        }
    }

    getMediosPago = async (Hoy) => {
        try {
            const response = await fetch(
                `/api/dashboard/get/ventas-medio-pago/${Hoy}`
            )
            const ReporteMediosPago = await response.json();
            this.setState({
                dataMediosPago: ReporteMediosPago.respuesta,
                isLoading: false
            });

            return ReporteMediosPago;
        }catch (error) {
            this.setState({error, isLoading: false})
        }
    }

    handleVerProductosAgotarStock() {
        this.props.history.push("/dashboard/productosporagotarstock/")
    }

    handleIrProcesarVales() {
        this.props.history.push("/procesarvales/")
    }

    handleVerVentasTurnosActivosEmpresa() {
        this.props.history.push("/dashboard/ventas/turnosactivos/empresa")
    }

    handleIrProductosMasVendidos() {
        this.props.history.push("/dashborad/productosmasvendidos")
    }

    handleReportesStock() {
        this.props.history.push("/dashborad/reportesstock")
    }


    render() {
        const { dataVentasDia, dataVentasPorSemana, MesActual, dataVentasPorMeses, dataMediosPago} = this.state;
        return (
            <section className="ventas-fpay-section-vh">
                <div className="container-fluid px-md-5">
                    <div className="mb-2 pt-3">
                        <h4 className="mt-2 text-center">REPORTES GENERALES</h4>
                        <div className="accordion pb-5" id="accordionExample">
                            <div className="abed__card-dashboard">
                                <div className="abed__card-header" id="headingOne">
                                    <h2 className="mb-0 text-center">
                                    <button
                                        className="btn"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                        style={{ width: '100%' }}
                                    >
                                        VENTAS DEL DIA
                                    </button>
                                    </h2>
                                </div>
                                <div className="collapse show" id="collapseOne" aria-labelledby="headingOne" data-parent="#accordionExample">
                                    <div className="card-body">
                                        {dataVentasDia ? (
                                            <div className="">
                                                <DashboardRecharts 
                                                    dataVentasDia={dataVentasDia}
                                                    dataMediosPago={dataMediosPago}
                                                />
                                            </div>
                                        ): (
                                            <div>Cargando Ventas del Dia</div>
                                        )} 
                                    </div>
                                </div>
                            </div>
                            <div className="abed__card-dashboard">
                                <div className="abed__card-header" id="headingTwo">
                                    <h2 className="mb-0 text-center">
                                    <button
                                        className="btn collapsed"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target="#collapseTwo"
                                        aria-expanded="false"
                                        aria-controls="collapseTwo"
                                        style={{ width: '100%' }}
                                    >
                                        VENTAS DEL MES {MesActual && `DE ${MesActual}`}
                                    </button>
                                    </h2>
                                </div>
                                <div className="collapse" id="collapseTwo" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                    <div className="card-body">
                                        {dataVentasPorSemana ? (
                                            <div className="">
                                                <DashboardVentasMes 
                                                  dataVentasPorSemana={dataVentasPorSemana} 
                                                  MesActual={MesActual} 
                                                />
                                            </div>
                                        ): (
                                            <div>Cargando Ventas del Mes</div>
                                        )} 
                                    </div>
                                </div>
                            </div>
                            <div className="abed__card-dashboard">
                                <div className="abed__card-header" id="headingThree">
                                    <h2 className="mb-0 text-center">
                                    <button
                                        className="btn collapsed"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target="#collapseThree"
                                        aria-expanded="false"
                                        aria-controls="collapseThree"
                                        style={{ width: '100%' }}
                                    >
                                        VENTAS HISTORICAS
                                    </button>
                                    </h2>
                                </div>
                                <div className="collapse" id="collapseThree" aria-labelledby="headingThree" data-parent="#accordionExample">
                                    <div className="card-body">
                                        {dataVentasPorMeses ? (
                                            <div className="">
                                                <DashboardVentasHistoricas 
                                                  dataVentasPorMeses={dataVentasPorMeses} 
                                                />
                                            </div>
                                        ): (
                                            <div>Cargando Ventas del Mes</div>
                                        )} 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <h4 className="d-flex justify-content-center">REPORTES PERSONALIZADOS</h4>
                        <div className="row w-100 m-0 mt-3 d-flex justify-content-center mb-5">
                            <div type="button" className="dashboard__content--item-g col-12 mt-5" title="Haz clic para ver detalles"
                                onClick={this.handleVerVentasTurnosActivosEmpresa}>
                                <div className="d-flex">
                                    <i className="fas fa-cash-register"></i>
                                    <span className="align-self-center">Ventas de los turnos activos</span>
                                </div>
                                <span className="d-flex justify-content-end">
                                    {this.state.TotalVentas &&
                                        "S/ " + this.state.TotalVentas.toLocaleString("en", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        })}
                                </span>
                            </div>

                            <div type="button" className="dashboard__content--item-d col-12 mt-5" title="Haz click para ver detalles"
                                onClick={this.handleVerProductosAgotarStock}>
                                <div>
                                    <i className="fas fa-boxes"></i>
                                    Productos Agotados o Próximos en Agotar Stock
                                </div>
                                <span className="d-flex justify-content-end">
                                    {this.state.TotalProductosAgotarStock &&
                                        this.state.TotalProductosAgotarStock}
                                </span>
                            </div>
                            <div hidden className="dashboard__content--item-g col-12 mt-5" type="button"
                                title="Haz click para ir a Procesar Vales" onClick={this.handleIrProcesarVales}>
                                <div>
                                    <i className="fas fa-hourglass-end"></i>
                                    Productos Pendientes en Procesar Vales
                                </div>
                                <span className="d-flex justify-content-end"> 
                                    {this.state.TotalProductosVales &&
                                        this.state.TotalProductosVales}
                                </span>
                            </div>

                            <div type="button" className="dashboard__content--item-d col-12 mt-5" title="Haz click para ver detalles"
                                onClick={this.handleIrProductosMasVendidos}>
                                <div>
                                    <i className="fas fa-barcode"></i>
                                    Productos más Vendidos
                                </div>

                            </div>

                            <div type="button" className="dashboard__content--item-g col-12 mt-5" title="Haz click para ver detalles"
                                onClick={this.handleReportesStock}>
                                <div>
                                    <i className="fas fa-boxes"></i>
                                    Reportes de Stocks
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
export default NuevoDashboard;